/**
 * teksten.js — de bovenbalk en de footer van de publieke pagina's, in NL en EN.
 *
 * Gebruikt door PubliekeNav en PubliekeFooter. site.test.js controleert dat NL
 * en EN dezelfde sleutels hebben, zodat een vertaling niet kan achterlopen.
 */

const NL = {
  nav: {
    overOns: 'Over Ons',
    kennisbank: 'Kennisbank',
    werkenBij: 'Werken bij',
    contact: 'Contact',
    demo: 'Demo',
    dashboard: 'Dashboard',
    inloggen: 'Inloggen',
    menu: 'Menu',
    taal: 'Taal',
    hoofdmenu: 'Hoofdmenu',
  },
  footer: {
    tagline: 'Het toetsplatform van de toekomst',
    platform: 'Platform',
    hoeWerktHet: 'Hoe werkt het',
    kennisbank: 'Kennisbank',
    demoAanvragen: 'Demo aanvragen',
    inloggen: 'Inloggen',
    support: 'Support',
    over: 'Over',
    overOns: 'Over Ons',
    contact: 'Contact',
    faq: 'Veelgestelde vragen',
    werkenBij: 'Werken bij',
    vacatures: 'Vacatures',
    openSollicitatie: 'Open sollicitatie',
    juridisch: 'Juridisch',
    privacy: 'Privacybeleid',
    voorwaarden: 'Algemene voorwaarden',
    subverwerkers: 'Subverwerkers',
    rechten: 'Alle rechten voorbehouden.',
    gemaakt: 'Gemaakt in Nederland door docenten voor docenten',
  },
};

const EN = {
  nav: {
    overOns: 'About Us',
    kennisbank: 'Knowledge Base',
    werkenBij: 'Careers',
    contact: 'Contact',
    demo: 'Demo',
    dashboard: 'Dashboard',
    inloggen: 'Log in',
    menu: 'Menu',
    taal: 'Language',
    hoofdmenu: 'Main menu',
  },
  footer: {
    tagline: 'The assessment platform of the future',
    platform: 'Platform',
    hoeWerktHet: 'How it works',
    kennisbank: 'Knowledge Base',
    demoAanvragen: 'Request a demo',
    inloggen: 'Log in',
    support: 'Support',
    over: 'About',
    overOns: 'About Us',
    contact: 'Contact',
    faq: 'FAQ',
    werkenBij: 'Careers',
    vacatures: 'Vacancies',
    openSollicitatie: 'Open application',
    juridisch: 'Legal',
    privacy: 'Privacy policy',
    voorwaarden: 'Terms and conditions',
    subverwerkers: 'Subprocessors',
    rechten: 'All rights reserved.',
    gemaakt: 'Made in the Netherlands by teachers, for teachers',
  },
};

export const SITE_TEKSTEN = { nl: NL, en: EN };

export function siteTeksten(lang = 'nl') {
  return SITE_TEKSTEN[lang] || NL;
}
